module.exports = __webpack_public_path__ + "img/notifyBlue.6acffc76.png";